import service from '@/store/services/vendors/vendors-service';

const state = {
    list: {},
    vendor: {},
    employee: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, vendor) => {
        state.vendor = vendor;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    },
    SET_SMS: (state, sms) => {
        state.sms = sms;
    },
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(vendor => {
                commit('SET_RESOURCE', vendor);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(vendor => {
                commit('SET_RESOURCE', vendor);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((vendor) => {
                commit('SET_RESOURCE', vendor);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((vendor) => {
                commit('SET_RESOURCE', vendor);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },

    upload ({ commit, dispatch }, { item, image }) {
        return service.upload(item, image)
            .then((url) => {
                commit('SET_URL', url);
            });
    },

    permissions ({ commit, dispatch }, { item, selected }) {
        return service.permissions(item, selected)
            .then((sms) => {
                commit('SET_SMS', sms);
            });
    },
    roles ({ commit, dispatch }, { item, role_name, selected }) {
        return service.roles(item, role_name, selected)
            .then((sms) => {
                commit('SET_SMS', sms);
            });
    },

    roleLists ({ commit, dispatch }, vendor) {
        return service.roleLists(vendor)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    employees ({ commit, dispatch }, vendor) {
        return service.employees(vendor)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page ? state.meta.page.total : 0,
    vendor: state => state.vendor,
    employee: (state) =>{
        return state.employee.map(employee=> ({
            uuid: employee.uuid,
            first_name: employee.first_name,
            middle_name: employee.middle_name,
            last_name: employee.last_name,
            phone_number: employee.phone_number,
            telephone_number: employee.telephone_number,
            email:employee.email,
            nida_number: employee.nida_number,
            gender: employee.gender,
            check_no: employee.check_no,
        }));
    },
    url: state => state.url,
    sms: state => state.sms,
    dropdown: (state) => {
        return state.list.map(vendor => ({
            id: vendor.id,
            name: vendor.name,
            description: vendor.description,
            address: vendor.address,
            phone_number: vendor.phone_number,
            telephone_number: vendor.telephone_number,
            email:vendor.email,
            website: vendor.website,
            logo: vendor.logo,
            business_name: vendor.business_name,
        }));
    }
};

const vendors = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default vendors;
